module.exports = __webpack_public_path__ + "media/images/registration/state_local_gov_employee_user-253995c9736a4e9fddcb8b976012677a.png";